<script setup lang="ts">
import { computed } from 'vue';
import { RouterView, useRoute } from 'vue-router';

defineProps<{ sessionKey: string }>();
const route = useRoute();
const tableRoute = computed(() => ['grid', 'candidate', 'sheet'].includes(String(route.name)));
const retained = computed(() => route.name === 'grid' || route.name === 'candidate'
  || (route.name === 'sheet' && route.params.code === 'base'));
const pageKey = computed(() => route.name === 'candidate' ? 'grid' : String(route.name));
</script>

<template>
  <RouterView v-slot="{ Component }">
    <!-- Держим готовые DOM и измерения двух больших таблиц. Другой лист использует
         общий sheets store, поэтому при выходе из этой пары освобождаем экземпляры. -->
    <KeepAlive v-if="retained" :key="sessionKey" :max="2">
      <component :is="Component" :key="pageKey" />
    </KeepAlive>
    <Transition v-else name="page" :mode="tableRoute ? undefined : 'out-in'" :css="!tableRoute">
      <component :is="Component" :key="`${sessionKey}:${pageKey}`" />
    </Transition>
  </RouterView>
</template>
